import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M7.82 10h.982v4.253h-1.33L6.15 11.78h-.168v2.472H5V10h1.33l1.322 2.472h.168V10ZM12.474 12.56H10.83v.716h2.21v.977H9.72V10h3.265v.977H10.83v.631h1.644v.953ZM17.662 10H18.7l-.49 4.253h-1.56l-.422-2.05h-.168l-.422 2.05H14.07L13.58 10h1.049l.305 2.918h.168l.381-1.728h1.327l.382 1.728h.168L17.665 10h-.003Z"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      d: "m12 .795 2.392 2.96.205.253.314-.085 3.675-.988.196 3.8.017.326.303.116 3.554 1.36-2.075 3.19-.177.273.177.273 2.075 3.19-3.554 1.36-.303.116-.017.325-.196 3.8-3.675-.987-.314-.085-.205.253L12 23.205l-2.392-2.96-.205-.253-.314.085-3.675.988-.196-3.8-.017-.326-.303-.116-3.554-1.36 2.075-3.19.178-.273-.178-.273-2.075-3.19 3.554-1.36.303-.116.017-.325.196-3.8 3.675.987.314.085.205-.253L12 .795Z"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "new"}) } }